import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authAPI, apiHelpers } from '../api/api';
import { validatePassword, passwordRequirements } from '../utils/passwordValidator';
import '../css/Login.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isValidToken, setIsValidToken] = useState(false);
  const [isCheckingToken, setIsCheckingToken] = useState(true);
  const [showRequirements, setShowRequirements] = useState(false);
  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        toast.error('Hiányzó token');
        navigate('/auth');
        return;
      }

      try {
        await authAPI.verifyResetToken(token);
        setIsValidToken(true);
      } catch (error) {
        toast.error('Érvénytelen vagy lejárt jelszó visszaállítási link');
        setTimeout(() => navigate('/auth'), 2000);
      } finally {
        setIsCheckingToken(false);
      }
    };

    verifyToken();
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate password strength
    const validation = validatePassword(password);
    if (!validation.isValid) {
      validation.errors.forEach(error => toast.error(error));
      return;
    }

    if (password !== confirmPassword) {
      toast.error('A két jelszó nem egyezik');
      return;
    }

    setIsLoading(true);

    try {
      const result = await authAPI.resetPassword(token, password);
      toast.success(result.message || 'Jelszó sikeresen megváltoztatva!');
      setTimeout(() => navigate('/auth'), 2000);
    } catch (error) {
      toast.error(apiHelpers.handleApiError(error));
    } finally {
      setIsLoading(false);
    }
  };

  if (isCheckingToken) {
    return (
      <div className="login-form" style={{ textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', color: '#555' }}>Token ellenőrzése...</h2>
      </div>
    );
  }

  if (!isValidToken) {
    return null;
  }

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <div style={{ textAlign: 'center', width: '100%', marginBottom: '15px' }}>
        <h2 style={{ fontSize: '2rem', margin: '0', lineHeight: '1.2' }}>Új jelszó</h2>
        <h2 style={{ fontSize: '2rem', margin: '0', lineHeight: '1.2' }}>megadása</h2>
      </div>
      <p style={{ fontSize: '14px', color: '#222', margin: '0 0 20px 0', textAlign: 'center', width: '100%' }}>
        Add meg az új jelszavadat a folytatáshoz.
      </p>
      <label htmlFor="password">Új jelszó</label>
      <input
        type="password"
        placeholder="Új jelszó..."
        value={password}
        onChange={e => setPassword(e.target.value)}
        onFocus={() => setShowRequirements(true)}
        required
        disabled={isLoading}
        minLength={8}
      />
      {showRequirements && (
        <div style={{ width: '100%', fontSize: '12px', color: '#555', marginTop: '-10px', marginBottom: '10px', textAlign: 'left' }}>
          <strong>Jelszó követelmények:</strong>
          <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
            {passwordRequirements.map((req, index) => (
              <li key={index}>{req}</li>
            ))}
          </ul>
        </div>
      )}
      <label htmlFor="confirmPassword">Jelszó megerősítése</label>
      <input
        type="password"
        placeholder="Jelszó újra..."
        value={confirmPassword}
        onChange={e => setConfirmPassword(e.target.value)}
        required
        disabled={isLoading}
        minLength={8}
      />
      <button type="submit" disabled={isLoading}>
        {isLoading ? 'Mentés...' : 'Jelszó megváltoztatása'}
      </button>
      <div style={{ marginTop: '15px', width: '100%', textAlign: 'center' }}>
        <span onClick={() => navigate('/auth')} style={{ color: '#333', fontSize: '0.97rem', cursor: 'pointer', textDecoration: 'underline' }}>
          Vissza a bejelentkezéshez
        </span>
      </div>
    </form>
  );
};

export default ResetPassword;
